import React from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/sections/Hero';
import Stats from '../../components/sections/Stats';
import Services from '../../components/sections/Services';
import Clients from '../../components/sections/Clients';
import Contact from '../../components/sections/Contact';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Stats />
      <Services />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;